import React from "react";
// import Question from "src/assets/question.png";
import { ZENDDESK_FAQ } from "src/constants";

const Footerpage: React.FC = () => {


    return (<>
   
         <div className="footer-leader" style={{ width: "100%" }}>
                      <div className="content-footer"
                        style={{
                          width: "100%",
                          height: "73px",
                          backgroundColor: "rgba(245, 245, 245, 1)",
                        }}
                      >
                        <div className="question-icon" onClick={() => window.open(ZENDDESK_FAQ, '_blank')} style={{ cursor: 'pointer' }}>
                          {/* <h4>Help<img src={Question} /></h4> */}
                        </div>
                      </div>
                    </div>
        </>);
};

export default Footerpage;



// WEBPACK FOOTER //
// ./src/shared/components/footer.tsx